import './AttributionTooltip.scss';
import { useCallback, useEffect, useState } from 'react';
import { AlertDialog } from '@Components/AlertDialog';
import { AttributionType, AttributionTypeConst } from '../dtc-commerce-mmm-types';

export const useAttributionTooltip = (attributionType: AttributionType) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (attributionType === AttributionTypeConst.RAW) {
      setShow(true);
    }
  }, [attributionType]);

  const dismiss = useCallback(() => setShow(false), []);

  return { show, dismiss };
};

interface AttributionTooltipProps {
  show: boolean;
  onDismiss: () => void;
}

const TooltipBody = () => (
  <div className='attribution-tooltip-body'>
    <p>
      You switched to the <strong>Direct</strong> attribution view.
    </p>
    <p>
      In the <strong>Actualized</strong> view (default), credit from demand capture channels (like
      branded search) is redistributed upstream to the demand generation channels (like TV and
      social) that drove the downstream activity.
    </p>
    <p>
      In the <strong>Direct</strong> view, each channel shows only what the model directly
      attributes — no redistribution.
    </p>
    <p>
      You&apos;ll notice demand capture channels show higher values and demand generation channels
      show lower values in this view.
    </p>
  </div>
);

export const AttributionTooltip = ({ show, onDismiss }: AttributionTooltipProps) => (
  <AlertDialog
    show={show}
    onHide={onDismiss}
    title='Understanding Direct vs Actualized'
    body={<TooltipBody />}
    primaryAction={{ onClick: onDismiss, label: 'Got it' }}
    escapable={false}
    className='attribution-tooltip-dialog'
  />
);
